console.log('SC Variants script loaded');

class SCVariantSelector {
  constructor() {
    this.form = document.querySelector('form[action*="/cart/add"]');
    this.variantRadios = document.querySelectorAll('input[type="radio"][name="id"]');
    this.priceElement = document.querySelector('.sc-product-price');
    
    this.init();
  }

  init() {
    this.variantRadios.forEach(radio => {
      radio.addEventListener('change', (e) => {
        this.updatePrice(e.target.value);
      });
    });
  }

  updatePrice(variantId) {
    fetch(`/products/star-citizen-auec?variant=${variantId}`)
      .then(response => response.text())
      .then(responseText => {
        const html = new DOMParser().parseFromString(responseText, 'text/html');
        const priceInfo = html.querySelector('[id^="price-template"]');
        if (priceInfo) {
          const regularPrice = priceInfo.querySelector('.price__regular .price-item');
          const salePrice = priceInfo.querySelector('.price__sale .price-item--sale');
          const comparePrice = priceInfo.querySelector('.price__sale .price-item--regular');
          
          let priceHtml = '';
          if (salePrice && comparePrice) {
            const salePriceValue = parseFloat(salePrice.innerHTML.replace(/[^0-9.]/g, ''));
            const comparePriceValue = parseFloat(comparePrice.innerHTML.replace(/[^0-9.]/g, ''));
            
            if (salePriceValue < comparePriceValue) {
              priceHtml = `<s>${comparePrice.innerHTML}</s> <span class="sale-price">${salePrice.innerHTML}</span> <span class="sale-badge">SALE</span>`;
            } else {
              priceHtml = salePrice.innerHTML;
            }
          } else {
            priceHtml = regularPrice.innerHTML;
          }
          
          this.priceElement.innerHTML = priceHtml;
        }
      });
  }}

document.addEventListener('DOMContentLoaded', () => {
  new SCVariantSelector();
});